import { accountKitApi, accountKitReducer } from "@nerdjs/account-kit";
import { networkMiddleware, networkReducer } from "@nerdjs/nerd-network";
import { notificationReducer } from "@nerdjs/nerd-ui";
import { combineReducers } from "redux";
import thunkMiddleware from "redux-thunk";
import { configureStore } from "@reduxjs/toolkit";
import { mainMiddleware } from "./mainMiddleware";
import { mercuryApi } from "./api/mercuryApi";
import { rhapsodySlice } from "../reducers/rhapsody";
import { museApi } from "./api/museApi";
import { rhapsodyApi } from "./api/rhapsodyApi";
import { local420Api } from "./api/local420Api";
import { accountApi } from "./api/accountApi";
import { librarianApi } from "./api/librarian";
import { unityApi } from "./api/unityApi";
import { postalApi } from "./api/postalApi";

const rootReducer = combineReducers({
  accountKitState: accountKitReducer,
  notification: notificationReducer,
  networkState: networkReducer,
  [rhapsodySlice.name]: rhapsodySlice.reducer,
  [mercuryApi.reducerPath]: mercuryApi.reducer,
  [museApi.reducerPath]: museApi.reducer,
  [postalApi.reducerPath]: postalApi.reducer,
  [unityApi.reducerPath]: unityApi.reducer,
  [librarianApi.reducerPath]: librarianApi.reducer,
  [rhapsodyApi.reducerPath]: rhapsodyApi.reducer,
  [local420Api.reducerPath]: local420Api.reducer,
  [accountApi.reducerPath]: accountApi.reducer,
  [accountKitApi.reducerPath]: accountKitApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export const store = configureStore({
  reducer: rootReducer,
  middleware: [
    thunkMiddleware,
    mainMiddleware,
    postalApi.middleware,
    unityApi.middleware,
    mercuryApi.middleware,
    museApi.middleware,
    rhapsodyApi.middleware,
    librarianApi.middleware,
    local420Api.middleware,
    accountApi.middleware,
    accountKitApi.middleware,
    networkMiddleware, // Always add networkMiddleware after your api middleware
  ],
});

export type AppDispatch = typeof store.dispatch;
